import { render, staticRenderFns } from "./TutoringRegistration.vue?vue&type=template&id=cebe4550&scoped=true"
import script from "./TutoringRegistration.vue?vue&type=script&lang=js"
export * from "./TutoringRegistration.vue?vue&type=script&lang=js"
import style0 from "./TutoringRegistration.vue?vue&type=style&index=0&id=cebe4550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebe4550",
  null
  
)

export default component.exports